import { useResizeObserver } from '@vueuse/core';
import { ref } from 'vue';

export interface Size {
  width: number;
  height: number;
}

export type UseResizeHandler = (sizes: Size) => void;

export default function useResize(onResize: UseResizeHandler) {
  const elementRef = ref<HTMLElement>();

  useResizeObserver(
    elementRef,
    ([
      {
        contentRect: { width, height },
      },
    ]) => onResize({ width, height }),
  );

  return elementRef;
}
